var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main"},[_c('Apresentation'),_c('Projects'),_c('Technologies',{attrs:{"technologiesFaB":['js', 'node' , 'java', 'php', 'git',
        'github', 'aws', 'linux'],"technologiesFaS":['database']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }